import { z } from "zod";
import {
  apiEnvelope,
  emptyEnvelopeSchema,
  pageSchema,
} from "@/shared/api/api-contract";

export const notificationCategorySchema = z.enum([
  "PRODUCT_UPDATE",
  "SYSTEM_NOTICE",
  "ACCOUNT_NOTICE",
]);

export const notificationBusinessTypeSchema = z.enum([
  "NEW_MODEL_RELEASE",
  "NEW_FEATURE_RELEASE",
  "PRICE_CHANGE",
  "MAINTENANCE",
  "ACCOUNT_NOTICE",
]);

export const notificationPrioritySchema = z.enum([
  "NORMAL",
  "IMPORTANT",
  "URGENT",
]);

export const notificationSchema = z.object({
  id: z.number().int().positive(),
  title: z.string(),
  summary: z.string(),
  body: z.string(),
  category: notificationCategorySchema,
  businessType: notificationBusinessTypeSchema,
  priority: notificationPrioritySchema,
  coverUrl: z.string().nullish(),
  actionText: z.string().nullish(),
  actionUrl: z.string().nullish(),
  pinned: z.boolean(),
  unread: z.boolean(),
  newMessage: z.boolean(),
  publishedAt: z.string(),
});

export const notificationPageEnvelopeSchema = apiEnvelope(
  pageSchema(notificationSchema),
);
export const notificationEnvelopeSchema = apiEnvelope(notificationSchema);
export const notificationPopupEnvelopeSchema = apiEnvelope(
  notificationSchema.nullish(),
);
export const notificationListEnvelopeSchema = apiEnvelope(
  z.array(notificationSchema),
);
export const notificationCountEnvelopeSchema = apiEnvelope(
  z.object({ count: z.number().int().nonnegative() }),
);
export const notificationClickEnvelopeSchema = apiEnvelope(
  z.object({ actionUrl: z.string() }).nullish(),
);
export const notificationActionEnvelopeSchema = emptyEnvelopeSchema;

export type NotificationCategory = z.infer<typeof notificationCategorySchema>;
export type NotificationBusinessType = z.infer<
  typeof notificationBusinessTypeSchema
>;
export type NotificationPriority = z.infer<typeof notificationPrioritySchema>;
export type MemberNotification = z.infer<typeof notificationSchema>;
export type NotificationPage = z.infer<
  typeof notificationPageEnvelopeSchema
>["data"];
